export default __webpack_public_path__ + "static/media/near-protocol-logo.72dff2d7.svg";